/**
 * Webhook integration naming convention.
 *
 * Every client gets ONE integration serving both pipelines (feedback + Calendly),
 * named after its client so the integrations table reads as a per-client index:
 *   display name: "TCPR-webhooks-calendly-and-feedback"
 *   slug (auto):  "tcpr-webhooks-calendly-and-feedback"
 * The slug becomes part of both webhook URLs — never rename an existing slug.
 */
export const INTEGRATION_NAME_SUFFIX = '-webhooks-calendly-and-feedback';

export function buildIntegrationDisplayName(clientCode: string): string {
  return `${clientCode}${INTEGRATION_NAME_SUFFIX}`;
}
